package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAug172025SportsGameXGoogleSigninPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/aug172025SportsGameXGoogleSignin.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/SportsGameX/aug172025-sports-game-x-google-signin")
@Composable
fun Aug172025SportsGameXGoogleSigninPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("aug-17-2025-sportsgamex-google-signin")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We prioritized Google SignIn as the first KMP module to be developed, since we needed it for the onboarding section of our mobile platforms.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This part was not a major challenge. Google SignIn has well written documentation for both Android and iOS. I just needed to bring both implementations together to complete our KMP module.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Google SignIn was merged into Firebase a couple of years ago. This made my work easier going forward, because we also needed to add Firebase Analytics and track user events.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Both the Android and iOS implementations were tightly integrated with the Firebase console. Having everything in one place also made the work easier. I managed to finish the task in less than half a sprint.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Injecting the module for Android was straightforward. I only needed to include the module as a submodule in the project and use it in the onboarding section.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Injecting for iOS was a bit more challenging, but nothing too concerning. I had to add a bash script to build the module as an ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("xcframework")
        }
        org.jetbrains.compose.web.dom.Text(", after which our iOS team could use the API in onboarding. They were so happy and couldn't believe what just happened. Getting rid of this kind of repetitive implementation will lift some weight on team shoulders.")
    }
}
